module.exports = __webpack_public_path__ + "static/lightning-prompt-02373b9ff756f174f3c6a4dd2d8e307f.png";